import React, { useEffect } from 'react';
import { getAssetPath } from '../utils/paths';

const Testimonial = () => {
  useEffect(() => {
    // Initialize Swiper for testimonials
    let swiper = null;
    
    if (window.Swiper) {
      const swiperElement = document.querySelector('.crm-testimonial__slide');
      if (swiperElement) {
        try {
          swiper = new window.Swiper('.crm-testimonial__slide', {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: true,
            autoplay: {
              delay: 5000,
              disableOnInteraction: false,
            },
            breakpoints: {
              768: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 3,
              }
            }
          });
        } catch (error) {
        }
      }
    }
    
    return () => {
      if (swiper && swiper.destroy) {
        try {
          const swiperElement = document.querySelector('.crm-testimonial__slide');
          if (swiperElement && swiperElement.swiper === swiper) {
            swiper.destroy(true, true);
          }
        } catch (error) {
        }
      }
    };
  }, []);

  const testimonials = [
    {
      rating: getAssetPath('/Helax/assets/img/icon/rating.png'),
      text: "Since implementing ABC CRM service in our organization, we have experienced a remarkable transformation in our customer management practices. The platform's intuitive interface and powerful automation tools have revolutionized the way we interact",
      avatar: getAssetPath('/Helax/assets/img/avatar/tm_avatar1.jpg'),
      name: 'Florida Campain',
      role: 'Web Developer'
    },
    {
      rating: getAssetPath('/Helax/assets/img/icon/rating.png'),
      text: "I have been using XYZ CRM service for over a year now, and I am extremely satisfied with the results. The platform is user-friendly, making it easy for me and my team to manage our customer relationships efficiently way of this ways.",
      avatar: getAssetPath('/Helax/assets/img/avatar/tm_avatar2.jpg'),
      name: 'Florida Campain',
      role: 'Web Developer'
    },
    {
      rating: getAssetPath('/Helax/assets/img/icon/rating.png'),
      text: "I cannot imagine running my business without PQR CRM service. It has become an indispensable tool in managing our customer relationships. The ability to centralize all customer data and communication in one place has saved us countless.",
      avatar: getAssetPath('/Helax/assets/img/avatar/tm_avatar3.jpg'),
      name: 'Florida Campain',
      role: 'Web Developer'
    },
    {
      rating: getAssetPath('/Helax/assets/img/icon/rating.png'),
      text: "I have been using XYZ CRM service for over a year now, and I am extremely satisfied with the results. The platform is user-friendly, making it easy for me and my team to manage our customer relationships efficiently way of this ways.",
      avatar: getAssetPath('/Helax/assets/img/avatar/tm_avatar1.jpg'),
      name: 'Florida Campain',
      role: 'Web Developer'
    }
  ];

  // return (
  //   <section className="crm-testimonial pos-rel pb-80">
  //     <div className="container">
  //       <div className="crm-title text-center mb-60">
  //         <h2 className="crm-title__heading">Our happy customer <br /> feedback</h2>
  //       </div>
  //     </div>
  //     <div className="crm-testimonial__slide swiper-container">
  //       <div className="swiper-wrapper">
  //         {testimonials.map((testimonial, index) => (
  //           <div key={index} className="crm-testimonial__item swiper-slide">
  //             <div className="rating mb-40">
  //               <img src={testimonial.rating} alt="5 Star Rating" />
  //             </div>
  //             <p>{testimonial.text}</p>
  //             <div className="crm-testimonial__author ul_li_center text-start mt-45">
  //               <div className="avatar">
  //                 <img src={testimonial.avatar} alt={testimonial.name} />
  //               </div>
  //               <div className="content">
  //                 <h4>{testimonial.name}</h4>
  //                 <span>{testimonial.role}</span>
  //               </div>
  //             </div>
  //             <div className="quote">
  //               <img src={getAssetPath('/Helax/assets/img/icon/quote-2.png')} alt="" />
  //             </div>
  //           </div>
  //         ))}
  //       </div>
  //     </div>
  //     <div className="crm-testimonial__shape">
  //       <div className="shape shape--1">
  //         <img src={getAssetPath('/Helax/assets/img/shape/tm_shape1.png')} alt="" />
  //       </div>
  //       <div className="shape shape--2" data-parallax='{"y" : 80}'>
  //         <img src={getAssetPath('/Helax/assets/img/shape/tm_shape2.png')} alt="" />
  //       </div>
  //     </div>
  //   </section>
  // );
};

export default Testimonial;

